import type { FC, ReactNode } from 'react'

import ScrambleText from '@/components/motion/scramble-text'
import SubscribeForm from '@/components/generals/subscribe-form'

const Newsletter: FC = (): ReactNode => {
    return (
        <section id='the-list' aria-label='Join the list' className='relative overflow-hidden bg-acid py-24 text-ink gutter md:py-36'>
            <div className='mx-auto flex max-w-6xl flex-col items-center text-center'>
                <p data-reveal='fade' className='label-mono'>
                    (08) — The List
                </p>

                <h2 className='mt-6 font-heading text-[clamp(52px,9vw,150px)] uppercase leading-[0.84]'>
                    <ScrambleText text='Join the list' />
                </h2>

                <p data-reveal='fade' className='mt-8 max-w-[50ch] lead text-ink/80'>
                    Drops sell out in hours. Get 24-hour early access, private archive sales and the occasional long letter from the studio.
                </p>

                <div data-reveal='fade' data-reveal-delay='0.15' className='mt-10 w-full max-w-xl text-left'>
                    <SubscribeForm source='home' />
                </div>
            </div>
        </section>
    )
}

export default Newsletter
